<template>
  <b-container class="mr-0" style="padding: 0;">
    <b-form-row v-if="true_values.length > 0" style="margin-bottom: -15px">
      <b-col>
        <legend class="col-form-label">{{ $t_netdb(object_attribute.description_global_scope) }}</legend>
      </b-col>
      <b-col cols="1">
        <b-button variant="outline-success" @click="true_values.push('')">
          <netvs-icon icon="add_item"></netvs-icon>
        </b-button>
      </b-col>
    </b-form-row>
    <b-form-row v-if="true_values.length === 0" style="margin-bottom: -15px">
      <b-col>
        <b-form-group
          :label="$t_netdb(object_attribute.description_global_scope)"
          :description="object_attribute.description_detail ? $t_netdb(object_attribute.description_detail) : undefined">
          <div class="text-center">
            <span class="text-muted font-italic">{{ $t('components.db_editor.empty_list') }}</span>
          </div>
        </b-form-group>
        <input type="hidden" :name="attribute_name + '__empty_list'" value=""/>
      </b-col>
      <b-col cols="1">
        <b-button variant="outline-success" @click="true_values.push('')">
          <netvs-icon icon="add_item"></netvs-icon>
        </b-button>
      </b-col>
    </b-form-row>
    <b-form-row style="margin-bottom: -5px" v-for="(v, index) in true_values" :key="v">
      <b-col>
        <APIObjectDataEditField :object_attribute="object_attribute" :attribute_preset="v"
                                :attribute_reference_name="attribute_reference_name"
                                :attribute_referencing="attribute_referencing"
                                :attribute_name="attribute_name"
                                :attribute_non_expert_nullable="attribute_non_expert_nullable"
                                :input_reducer="input_reducer"
                                :show_description="(index+1) === true_values.length"
                                :show_label="false"
                                v-bind:key="`${attribute_name}${index}`"></APIObjectDataEditField>
      </b-col>
      <b-col cols="1">
        <b-button variant="outline-danger" @click="true_values.splice(index, 1)" :disabled="true_values.length == 0">
          <netvs-icon icon="delete"></netvs-icon>
        </b-button>
      </b-col>
    </b-form-row>
  </b-container>
</template>

<script>
import APIObjectDataEditField from '@/components/db-editor/APIObjectDataEditField.vue'

export default {
  name: 'APIObjectDataEditFieldList',
  components: {APIObjectDataEditField},
  methods: {
    normalize_preset(val) {
      if (val === undefined || val === null) {
        return []
      }
      if (typeof val === 'string') {
        return val === '' ? [] : [val]
      }
      if (Array.isArray(val)) {
        return val.slice()
      }
      return []
    }
  },
  data: function () {
    return {
      true_values: this.normalize_preset(this.attribute_preset)
    }
  },
  watch: {
    attribute_preset(val) {
      this.true_values = this.normalize_preset(val)
    }
  },
  props: {
    object_attribute: {
      required: true
    },
    attribute_non_expert_nullable: {
      required: false,
      default() {
        return false
      }
    },
    attribute_referencing: null,
    attribute_reference_name: null,
    attribute_preset: null,
    attribute_name: {
      type: String,
      required: true
    },
    input_reducer: {
      default() {
        return null
      }
    },
  }
}
</script>

<style scoped>

</style>
